import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Offboarding from "../features/offboarding";
import EntryOffboardingDetailCollabPage from "../features/offboarding/DetailCollabPage";
import { OffboardingArchivedCollabPage } from "../features/offboarding/DetailCollabPage/OffboardingArchivedCollabPage";
import ListOffboarding from "../features/offboarding/components/ListOffboarding";

export const offboardingRoutes = (
    <Route
        path={ROUTES.offboarding.home}
        element={<Offboarding />}
        key="offboarding"
    >
        <Route
            index
            path={ROUTES.offboarding.detail}
            element={<EntryOffboardingDetailCollabPage />}
        />
        <Route
            index
            path={ROUTES.offboarding.archived}
            element={<OffboardingArchivedCollabPage />}
        />
        <Route path={ROUTES.offboarding.home} element={<ListOffboarding />} />
    </Route>
);
